import React, { useState, useRef } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import './Carousel3D.css';

const arrowImages = {
  default: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745260529/ebm/arrow-default_gaubba.png',
  hover: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745260529/ebm/arrow-hover_j6lfax.png',
  click: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745260529/ebm/arrow-clic_ryomnv.png',
};

const arrowImagesR = {
  default: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745262742/ebm/arrow-default-r_vggqik.png',
  hover: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745263004/ebm/arrow-hover-r_cjwkkb.png',
  click: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745262036/ebm/arrow-clic-r_y5omw3.png',
};

export default function CarouselArticulos({ wpData }) {
  const [current, setCurrent] = useState(0);
  const [leftArrow, setLeftArrow] = useState(arrowImages.default);
  const [rightArrow, setRightArrow] = useState(arrowImagesR.default);
  const startX = useRef(0);

  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  let cardsToShow = 1;
  if (isSm) cardsToShow = 2;
  else if (isMdUp) cardsToShow = 3;

  if (!Array.isArray(wpData) || wpData.length === 0) {
    return (
      <Box sx={{ color: '#666', textAlign: 'center', py: 4 }}>
        No hay artículos disponibles.
      </Box>
    );
  }

  const filteredData = wpData.slice(0, 6); // Mostrar solo 6
  const cardCount = filteredData.length;

  const handlePrev = () => setCurrent((prev) => (prev - 1 + cardCount) % cardCount);
  const handleNext = () => setCurrent((prev) => (prev + 1) % cardCount);

  const handleTouchStart = (e) => (startX.current = e.touches[0].clientX);
  const handleTouchMove = (e) => {
    const deltaX = e.touches[0].clientX - startX.current;
    if (Math.abs(deltaX) > 50) {
      deltaX > 0 ? handlePrev() : handleNext();
      startX.current = e.touches[0].clientX;
    }
  };

  const getCardData = (index) => {
    const realIndex = (index + cardCount) % cardCount;
    return filteredData[realIndex];
  };

  const arrowStyle = {
    position: 'absolute',
    top: '50%',
    width: 'auto',
    height: '40px',
    cursor: 'pointer',
    transform: 'translateY(-50%)',
    zIndex: 100,
  };

  return (
    <Box className="carousel-container-blog" position="relative" overflow="hidden">
      <Box
        component="img"
        src={leftArrow}
        alt="left"
        sx={{ ...arrowStyle, left: '10px' }}
        onClick={handlePrev}
        onMouseEnter={() => setLeftArrow(arrowImages.hover)}
        onMouseLeave={() => setLeftArrow(arrowImages.default)}
        onMouseDown={() => setLeftArrow(arrowImages.click)}
        onMouseUp={() => setLeftArrow(arrowImages.hover)}
      />

      <Box
        className="carousel"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={3}
      >
        {[...Array(cardsToShow)].map((_, offset) => {
          const card = getCardData(current + offset);
          if (!card) return null;

          const title = card.titulo || 'Sin título';
          const link = card.enlace || '#';
          const imageUrl = card.imagen || 'https://via.placeholder.com/260x150?text=Sin+imagen';
          const description = card.descripcion?.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 100) || '...';

          return (
            <Box
              key={link}
              component="a"
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                textDecoration: 'none',
                borderRadius: '15px',
                overflow: 'hidden',
                maxWidth: '260px',
                flexShrink: 0,
                bgcolor: 'white',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '5px 5px 15px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '8px 8px 20px rgba(0,0,0,0.2)',
                },
                '&:active': {
                  boxShadow: 'inset -5px -5px 10px rgba(0,0,0,0.2)',
                },
              }}
            >
              <Box
                component="img"
                src={imageUrl}
                alt="Imagen del Artículo"
                width="100%"
                height="148px"
                sx={{ p: 1, borderRadius: 4, objectFit: 'cover' }}
              />
              <Box sx={{ p: 3, pt: 0 }} display="flex" flexDirection="column" justifyContent="space-between" height="auto">
                <Box my={1} width="100%" height="1px" bgcolor="#d3d3d3" />
                <Typography fontWeight="bold" fontSize="15px" textAlign="left" mb={1} color="black" sx={{ lineHeight: 1.2 }}>
                  {`${title.substring(0, 40)}...`}
                </Typography>
                <Typography fontSize="13px" color="text.secondary" textAlign="left">
                  {description}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>

      <Box
        component="img"
        src={rightArrow}
        alt="right"
        sx={{ ...arrowStyle, right: '10px' }}
        onClick={handleNext}
        onMouseEnter={() => setRightArrow(arrowImagesR.hover)}
        onMouseLeave={() => setRightArrow(arrowImagesR.default)}
        onMouseDown={() => setRightArrow(arrowImagesR.click)}
        onMouseUp={() => setRightArrow(arrowImagesR.hover)}
      />
    </Box>
  );
}
